<template>
  <mtd-col>
    <!-- 顶部按钮栏 -->
    <mtd-row>
      <mtd-col :span="12" class="height-full">
        <span class="page-title-32">外发审计申请记录</span>
      </mtd-col>
      <mtd-col :span="12" class="height-full text-right">
        <mtd-button type="primary" @click="open_create_modal">新增申请</mtd-button>
      </mtd-col>
    </mtd-row>
    <!-- 搜索框 -->
    <mtd-form inline :label-width="74">
      <mtd-row style="margin-top: 16px;background: #F7F7F7;padding: 12px 16px;" :gutter="16">
        <mtd-col :span="8" style="padding-left: 0;">
          <mtd-form-item label="查看个人:" style="margin-bottom: 0;width: 100%;">
            <mtd-input type="text" style="width: 100%;" placeholder="请输入MISID"
                       v-model="search_form.targetMis" :clearable="true"/>
          </mtd-form-item>
        </mtd-col>
        <mtd-col :span="8">
          <mtd-form-item label="工单状态:" style="margin-bottom: 0;width: 100%;">
            <mtd-select placeholder="请选择工单状态" v-model="search_form.status" style="width: 100%;"
                        :clearable="true">
              <mtd-option :value="0" label="审核中"/>
              <mtd-option :value="1" label="审核通过"/>
              <mtd-option :value="2" label="审核未通过"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-col>
        <mtd-col :span="8" style="padding-right: 0; text-align: right;">
          <mtd-button type="text-primary" style="width: 70px;" @click="reset_search_form">重置</mtd-button>
          <mtd-button ghost type="primary" style="width: 80px;" @click="search_table_data">搜索</mtd-button>
        </mtd-col>
      </mtd-row>
    </mtd-form>
    <!-- 表格 -->
    <mtd-row style="margin-top:12px;">
      <mtd-col :span="24">
        <mtd-table size="small" :data="apply_list" :tooltip-props="{ size: 'small' }">
          <mtd-table-column prop="applyMis" label="申请人" width="200" show-overflow-tooltip/>
          <mtd-table-column prop="targetMis" label="查看个人MisId" show-overflow-tooltip/>
          <mtd-table-column prop="targetOrg" label="查看组织架构" show-overflow-tooltip/>
          <mtd-table-column prop="reason" label="申请原因" show-overflow-tooltip/>
          <mtd-table-column prop="bpmStatus" label="审批状态" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">
                <i class='mtdicon mtdicon-time-o' style="font-size:14px;color: #0a70f5"/>审批中
              </span>
              <span v-if="scope.row.status === 1">
                <i class='mtdicon mtdicon-success-o' style="font-size:14px;color: #00b365"/>已通过
              </span>
              <span v-if="scope.row.status === 2">
                <i class='mtdicon mtdicon-error-o' style="font-size:14px;color: #f5483b"/>已拒绝
              </span>
              <span v-if="scope.row.status === 6">
                <i class='mtdicon mtdicon-warning-circle-o' style="font-size:14px;color: #ffc300"/>已关闭
              </span>
            </template>
          </mtd-table-column>
          <mtd-table-column label="操作" width="112">
            <template slot-scope="scope">
              <mtd-button type="text" size="small" class="operate-btns" style="padding-left: 0;"
                          @click="delete_apply(scope.row.id)">
                删除
              </mtd-button>
              <a :href="scope.row.bpmDetailUrl" target="_blank" :disabled="!scope.row.bpmDetailUrl">
                <mtd-button type="text" size="small" class="operate-btns" style="padding-right: 0;"
                            :disabled="!scope.row.bpmDetailUrl">
                  查看审批
                </mtd-button>
              </a>
            </template>
          </mtd-table-column>
        </mtd-table>
      </mtd-col>
    </mtd-row>
    <!-- 分页 -->
    <div class="pagination-block" style="margin-top: 16px; text-align: right">
      <mtd-pagination size="small" show-size-changer show-total :total="search_form.total"
                      :page-size="search_form.limit" :current-page.sync="search_form.page" @change="page_change"/>
    </div>
    <!-- 添加申请Modal -->
    <mtd-modal title="查看外发记录申请" width="800px" v-model="create_apply_modal" @close="close_create_modal">
      <mtd-form :label-width="112">
        <mtd-form-item label="申请人:">
          <mtd-input type="text" style="width: 100%;" v-model="this.login_user.name" :disabled="true"/>
        </mtd-form-item>
        <mtd-form-item label="抄送人:">
          <mtd-select v-model="form_data.cc_list" placeholder="请输入姓名、MIS号查找" multiple :filterable="true"
                      :remote="true" style="width: 100%" :remote-method="searchPerson" :debounce="500"
                      key="cc_list_select">
            <mtd-option v-for="item in person_groups" :key="item.name + '/' + item.mis"
                        :label="item.name + '/' + item.mis" :value="item.mis"/>
          </mtd-select>
        </mtd-form-item>
        <mtd-form-item label="申请查看个人:">
          <mtd-select v-model="form_data.targetMisList" placeholder="请输入姓名、MIS号查找" multiple :filterable="true"
                      :remote="true" style="width: 100%" :remote-method="searchPerson" :debounce="500"
                      key="targetMis_list_select">
            <mtd-option v-for="item in person_groups" :key="item.name + '/' + item.mis"
                        :label="item.name + '/' + item.mis" :value="item"/>
          </mtd-select>
        </mtd-form-item>
        <mtd-form-item label="申请查看组织:">
          <mtd-select v-model="form_data.targetOrgList" placeholder="请输入关键字查找" multiple :filterable="true"
                      :remote="true" style="width: 100%" :remote-method="searchDepart" :debounce="500"
                      key="targetOrg_list_select">
            <mtd-option v-for="item in depart_groups" :key="item.orgIdPath" :label="item.orgNamePath"
                        :value="item"/>
          </mtd-select>
        </mtd-form-item>
        <mtd-form-item label="申请原因:" style="margin-bottom: 0;">
          <mtd-textarea placeholder="请输入申请原因" v-model="form_data.reason" style="width: 100%;" rows="5"/>
        </mtd-form-item>
      </mtd-form>
      <div slot="footer" class="demo-modal-footer" style="padding-top: 12px;">
        <mtd-button @click="close_create_modal">取消</mtd-button>
        <mtd-button type="primary" @click="submit_create_modal" :disabled="create_modal_valid">确定</mtd-button>
      </div>
    </mtd-modal>
  </mtd-col>
</template>

<script>

import {mapActions} from "vuex";
import moment from "moment";
import {BPM_STATUS} from "@/constants/bpm_file"

export default {
  name: "other_view_apply",
  filters: {
    dateTimeFormat(dateTime) {
      return moment(dateTime)
        .utcOffset(480)
        .format('YYYY-MM-DD HH:mm:ss');
    },
    // 为审批状态转换中文
    BpmStatusFilter(status) {
      return BPM_STATUS[status]
    },
  },
  data() {
    return {
      search_form: {
        targetMis: null,
        status: null,
        limit: 10,
        page: 1,
        total: 0,
      },
      apply_list: [],
      create_apply_modal: false,
      form_data: {
        id: null,
        cc_list: [],
        targetMisList: [],
        targetOrgList: [],
        reason: null,
      },
      person_groups: [],
      depart_groups: [],
    }
  },
  computed: {
    login_user() {
      return this.$store.getters.get_login_user;
    },
    create_modal_valid() {
      if ((!this.form_data.targetMisList || this.form_data.targetMisList.length === 0) &&
        (!this.form_data.targetOrgList || this.form_data.targetOrgList.length === 0)) {
        return true;
      }
      if (!this.form_data.reason || this.form_data.reason === '') {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.list_table_data();
  },
  methods: {
    ...mapActions({
      'list_apply': 'queryFileOutApplyCheckList',
      'submit_apply': 'submitFileOutApplyCheck',
      'api_delete_apply': 'deleteFileOutApplyCheck',
      'query_mis_id_list': 'query_mis_id_list',
      'query_org_list': 'query_org_info_list',
    }),
    search_table_data() {
      this.clear();
      this.list_table_data();
    },
    list_table_data() {
      this.list_apply(this.search_form).then((res) => {
        let data = res.data;
        this.apply_list = data.items;
        this.search_form.total = data.total;
        this.search_form.page = data.currentPage;
        this.search_form.limit = data.limit;
      });
    },
    clear() {
      this.search_form.total = 0;
      this.search_form.page = 1;
      this.search_form.limit = 10;
    },
    page_change(current, size) {
      this.search_form.page = current;
      this.search_form.limit = size;
      this.list_table_data();
    },
    reset_search_form() {
      this.search_form.targetMis = null;
      this.search_form.status = null;
    },
    open_create_modal() {
      this.create_apply_modal = true;
    },
    close_create_modal() {
      this.create_apply_modal = false;
      this.form_data = {
        id: null,
        cc_list: [],
        targetMisList: [],
        targetOrgList: [],
        reason: null,
      };
      this.person_groups = [];
    },
    submit_create_modal() {
      this.form_data.applyMis = this.login_user.mis;
      this.form_data.cc = this.form_data.cc_list.join(",");
      // 数据添加
      let detailList = [];
      let targetMis = [];
      let targetOrg = [];
      if (this.form_data.targetMisList && this.form_data.targetMisList.length > 0) {
        this.form_data.targetMisList.forEach((item) => {
          detailList.push({dataType: 'MIS', dataId: item.mis, dataValue: item.name});
          targetMis.push(`${item.name}(${item.mis})`);
        });
      }
      if (this.form_data.targetOrgList && this.form_data.targetOrgList.length > 0) {
        this.form_data.targetOrgList.forEach((item) => {
          detailList.push({dataType: 'ORGANIZATION', dataId: item.orgId, dataValue: item.orgNamePath});
          targetOrg.push(item.orgNamePath);
        });
      }
      this.form_data.detailList = detailList;
      if (targetMis && targetMis.length > 0) {
        this.form_data.targetMis = targetMis.join(",");
      }
      if (targetOrg && targetOrg.length > 0) {
        this.form_data.targetOrg = targetOrg.join(",");
      }
      this.submit_apply(this.form_data).then(() => {
        this.$mtd.message.success('申请提交成功！');
        this.close_create_modal();
        this.list_table_data();
      });
    },
    // 搜索mis
    searchPerson(keyword) {
      if (keyword != null && keyword !== "") {
        this.query_mis_id_list({keyword}).then(res => {
          this.person_groups = res.data
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    // 搜索BU BG
    searchDepart(keyword) {
      if (keyword != null && keyword !== "") {
        keyword = keyword.replace(/\//g, "-");
        this.query_org_list({keyword}).then(res => {
          this.depart_groups = res.data
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    delete_apply(id) {
      this.$mtd.confirm({
        title: "删除申请",
        message: '删除后不可恢复',
        width: '430px',
        showCancelButton: true,
        type: 'warning',
        okButtonText: '删除',
        okButtonProps: {
          type: 'danger',
        },
        // 点击确定
        onOk: () => {
          this.api_delete_apply({id}).then(() => {
            this.$mtd.message.success('删除任务成功');
            this.list_table_data();
          })
        }
      });
    }
  }
}
</script>

<style>
@import "../../../styles/reset_table.css";

.mtd-table-cell button.operate-btns {
  color: #0a70f5;
  border: none;
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
}
</style>
